import request from '@/utils/request';export const pageStockLogs=params=>request({url:'/dkmall/stock-logs',method:'get',params})
